<template>
  <div class="layout--full-page w-full">
    <div
      class="w-full h-full bg-img vx-row no-gutter flex flex-col items-center"
    >
      <div class="vx-col md:w-2/3 m-4 text-center p-5">
        <div class="flex justify-between items-center mb-10">
          <div>
            <img src="/kab-badung.png" alt="login" class="mt-5" width="100px" />
          </div>
          <div>
            <img src="/ribbon.png" alt="login" class="mt-5" width="150px" />
          </div>
          <div>
            <img src="/logo.png" alt="login" class="mt-5" width="100px" />
          </div>
        </div>

        <h1 class="mt-5 mb-10" style="font-size: 40px; font-weight: 900">
          PAKTA INTEGRITAS
        </h1>
        <div class="text-left text-xl mt-5">
          <div class="text-2xl mb-5 font-semibold">
            Menyatakan bahwa saya akan melaksanakan ketentuan sebagai berikut :
          </div>
          <div class="flex items-center mb-5">
            <div class="pr-5">
              <img src="/corruption-2.png" alt="login" width="50px" />
            </div>
            <div class="text-left text-xl">
              Tidak melakukan tindak pidana
              <b>Korupsi, Kolusi dan Nepotisme</b> di lingkungan Mal Pelayanan
              Publik Kabupaten Badung.
            </div>
          </div>
          <div class="flex items-center mb-5">
            <div class="pr-5">
              <img src="/crime.png" alt="login" width="50px" />
            </div>
            <div class="text-left text-xl">
              Tidak melakukan tindakan yang <b>melanggar hukum</b> di lingkungan
              Mal Pelayanan Publik Kabupaten Badung.
            </div>
          </div>
          <div class="flex items-center mb-5">
            <div class="pr-5">
              <img src="/corruption.png" alt="login" width="50px" />
            </div>
            <div class="text-left text-xl">
              Tidak melakukan <b>gratifikasi</b> dengan memberikan imbalan
              (Uang, Makan Gratis, Penginapan Gratis, Tiket Pesawat, Diskon, dan
              imbalan lainnya) kepada petugas Mal Pelayanan Publik Kabupaten
              Badung
            </div>
          </div>
        </div>
        <div class="text-left text-xl mt-10">
          Jika melanggar ketentuan diatas, saya siap menerima sangsi sesuai
          dengan ketentuan perudang-undangan yang berlaku.
        </div>
        <div class="text-left text-xl mt-2">
          Silakan mengisi nama lengkap dan menekan tombol setuju untuk
          menandatangi PAKTA INTEGRITAS
        </div>
        <div class="mt-10 flex">
          <input
            class="input-text"
            type="text"
            v-model="name"
            @click="onShowKeyboard('name')"
            placeholder="Masukan nama anda"
          />
        </div>
        <div class="mt-5" v-show="showKeyboard">
          <div class="flex justify-end">
            <div class="btn-keyboard mb-2" @click="onHideKeyboard">
              Sembunyikan Keyboard
            </div>
          </div>
          <SimpleKeyboard @onChange="onChange" :input="name" />
        </div>
        <div class="mt-10 flex">
          <input
            class="input-text"
            type="text"
            v-model="email"
            @click="onShowKeyboard('email')"
            placeholder="Masukan Email / No. Hp anda"
          />
        </div>
        <div class="mt-5" v-show="showKeyboardEmail">
          <div class="flex justify-end">
            <div class="btn-keyboard mb-2" @click="onHideKeyboard">
              Sembunyikan Keyboard
            </div>
          </div>
          <SimpleKeyboard
            keyboardClass="simple-keboard-email"
            @onChange="onChangeEmail"
            :input="email"
          />
        </div>
        <vs-button
          class="mt-5 w-full"
          @click="onSubmit"
          :disabled="loading || !validated"
          >Setuju</vs-button
        >
      </div>

      <integrity-statistic ref="statistic"></integrity-statistic>
    </div>
    <modal :active.sync="modal" :classModal="''">
      <div slot="header">
        <div
          class="
            vx-col
            flex flex-col
            items-center
            text-success
            justify-center
            m-2
          "
        >
          <div class="mb-5">
            <img
              src="@/assets/images/elements/decore-left.png"
              alt="login"
              class="decore-left"
              width="80px"
            />
            <img src="/ribbon.png" alt="login" class="mt-5" width="80px" />
            <img
              src="@/assets/images/elements/decore-right.png"
              alt="login"
              class="decore-right"
              width="80px"
            />
          </div>
          <h3 class="text-success font-extrabold">TERIMA KASIH</h3>
        </div>
        <div class="vx-col mt-3 mb-5">
          <div class="text-center font-semibold">{{ modalName }}</div>
          <div class="text-center mt-3">
            telah berpartisipasi dalam menandatangi
          </div>
          <div class="text-center font-bold mt-2">PAKTA INTEGRITAS</div>
          <div class="text-center font-bold mt-2">
            <vs-button class="mt-5" @click="modal = false" :disabled="loading"
              >Tutup</vs-button
            >
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<style scoped>
.input-text {
  width: 100%;
  padding: 10px 10px;
  font-size: 28px;
  color: grey;
  border: none;
  border-radius: 8px;
}

.btn-keyboard {
  padding: 5px 10px;
  cursor: pointer;
  color: grey;
  border: none;
  border-radius: 5px;
  background: white;
}

.input-text::placeholder {
  color: #ddd;
}

.decore-left {
  position: absolute;
  top: 0;
  left: 0;
  width: 120px;
}

.decore-right {
  position: absolute;
  top: 0;
  right: 0;
  width: 120px;
}
</style>

<script>
// import Axios from "axios";
// import Vue from "vue";
import Modal from "@/components/modal/Modal.vue";
import SimpleKeyboard from "./SimpleKeyboard";
import IntegrityStatistic from "./IntegrityStatistic.vue";

export default {
  components: {
    SimpleKeyboard,
    Modal,
    IntegrityStatistic,
  },
  data() {
    return {
      name: "",
      email: "",
      showKeyboard: false,
      showKeyboardEmail: false,
      loading: false,
      modal: false,
      modalName: "",
    };
  },
  mounted() {},
  methods: {
    onChange(input) {
      this.name = input;
    },

    onChangeEmail(input) {
      this.email = input;
    },
    // onKeyPress(button) {

    // },
    onInputChange(input) {
      this.name = input.target.value;
    },
    onSubmit() {
      this.loading = true;
      if (this.validated) this.postData();
      else this.notValidated();
    },

    postData() {
      var data = this.getPostData();

      this.$http
        .post(`/app/general/integrity-pact`, data)
        .then(() => {
          this.loading = false;
          this.modalName = this.name;
          this.modal = true;
          this.name = "";
          this.email = "";
          this.$refs.statistic.fetchData();
        })
        .catch((e) => {
          this.loading = false;
          this.parseError(e);
        });
    },
    getPostData() {
      if (this.isEmail) {
        return {
          name: this.name,
          email: this.email,
        };
      } else if (this.isPhone) {
        return {
          name: this.name,
          phone: this.email,
        };
      }
    },

    notValidated() {
      this.$vs.notify({
        title: "GAGAL",
        text: "Silakan lengkapi data terlebih dahulu !",
        color: "danger",
        iconPack: "feather",
        icon: "icon-alert-circle",
        time: 6000,
      });
      this.loading = false;
    },

    onShowKeyboard(type) {
      if (type == "email") {
        this.showKeyboard = false;
        this.showKeyboardEmail = true;
      } else {
        this.showKeyboard = true;
        this.showKeyboardEmail = false;
      }
    },
    onHideKeyboard() {
      this.showKeyboard = false;
      this.showKeyboardEmail = false;
    },
  },
  computed: {
    isEmail() {
      if (
        this.email.match(
          /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    isPhone() {
      if (
        this.email.match(
          /^(\+{0,})(\d{0,})([(]{1}\d{1,3}[)]{0,}){0,}(\s?\d+|\+\d{2,3}\s{1}\d+|\d+){1}[\s|-]?\d+([\s|-]?\d+){1,2}(\s){0,}$/gm
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    validated() {
      return this.name != "" && (this.isEmail || this.isPhone);
    },
  },
};
</script>
